<template>
  <div class="content_alliances">
    <div class="title">
      <!-- <h1>Alianzas</h1> -->
      <div class="category">
        <h3>Categoría de Alianza: </h3><strong>{{ category_name }}</strong>
      </div>
    </div>
    <hr class="separador">

    <!-- Desktop -->
    <div class="container_desktop">
      <div class="desktop" v-for="image in alliances_desktop" :key="image.id">
        <img
          v-if="image.description == null"  
          @click="irRedirection(currentAlliance, image.name)" 
          :src="image.url"
          class="image_desktop"
          alt="Alianzas"
        >
      </div>
    </div>

    <!-- Tablet -->
    <div class="container_tablet">
      <div class="tablet" v-for="image in alliances_desktop" :key="image.id">
        <img 
          v-if="image.description == null"
          @click="irRedirection(currentAlliance, image.name)"
          :src="image.url"
          class="image_tablet"
          alt="Alianzas"
        >
        <span v-if="category_name == 'Lavaderos' && (image.city != null && image.city != 'null')" class="city"><strong>{{ image.city }}</strong></span>
      </div>
    </div>

    <!-- Mobile -->
    <div class="container_mobile">
      <div class="mobile" v-for="image in alliances_desktop" :key="image.id">
        <img
          v-if="image.description == null"
          @click="irRedirection(currentAlliance, image.name)"
          :src="image.url"
          class="image_mobile"
          alt="Alianzas"
        >
        <span v-if="category_name == 'Lavaderos' && (image.city != null && image.city != 'null')" class="city"><strong>{{ image.city }}</strong></span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import $ from "jquery";

export default {
  name: "alliances",
  data(){
    return {
      category_name: null,
      alliances: [],
      alliances_desktop: [],
    }
  },
  methods: {
    getAlliances(name){
      if (name.includes("-")){
        name = name.replace(/-/g, " ");
      }
      axios
      .get(`api/file/get/alliances/${name}`)
      .then(res => {
        this.alliances = [];
        this.alliances_desktop = [];
        this.alliances = res.data.data;
        this.alliances.forEach(element => {
          if(element.id == 5){
            element.files.forEach(ele => {
              if(ele.description == null || ele.description == 2){
                this.alliances_desktop.push(ele);
              }
            });
          }
        });
        // console.log('this.alliances: ', JSON.stringify(this.alliances));
      })
      .catch(error => {
        console.log('error: ', error);
      });
    },
    irRedirection(currentAlliance, name) {
      this.$router.push({ name: "allianceDetail", params: { alliance: currentAlliance, name: name, id: name } });
    },
    async onRouteChange(){
      const currentUrl = window.location.href;
      const myArray = currentUrl.split("alliances/");
      const name = decodeURI(myArray[1]);
      await this.getAlliances(name);
      const url_sin_espacios = name.replace(/ /g, "-");
      history.replaceState(null, null, url_sin_espacios);
      this.category_name = url_sin_espacios;
    },
  },
  watch: {
    '$route'(){
      this.onRouteChange();
    },
  },
  mounted(){
    this.onRouteChange();
  }
}
</script>

<style scoped>
.content_alliances{
  padding-top: 80px;
  padding-bottom: 30px;
  background-color: #eaeaea;
}
.title{
  margin: auto;
}
.title h1{
  color: #dc3545;
  font-weight: bold;
}
.category{
  display: flex;
  justify-content: center;
  align-items: center;
}
.category h3{
  color: black;
  font-weight: bold;
  padding: 5px 10px 5px 5px;
}
.category > strong{
  color: #dc3545;
  font-size: 25px;
  margin-bottom: 5px;
}
.separador{
  max-width: 80%;
  margin: 0px auto 25px auto;
  background-color: #dc3545;
  padding: 1px;
}
/* Cuadriculas desktop */
.container_desktop{
  max-width: 80%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}
.desktop{
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.image_desktop{
  width: 100%;
  height: auto;
  border-radius: 5px;
}
/* Cuadriculas tablet */
.container_tablet{
  max-width: 90%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}
.tablet{
  position: relative;
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.image_tablet{
  width: 100%;
  height: auto;
  border-radius: 5px;
}
/* Cuadriculas mobile */
.container_mobile{
  max-width: 95%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
}
.mobile{
  position: relative;
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.image_mobile{
  width: 100%;
  height: auto;
  border-radius: 5px;
}
.city{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 10px;
  font-size: 20px;
  border-radius: 3px;
}

@media (min-width: 780px){
  .desktop{
    display: block !important;
  }
  .tablet{
    display: none !important;
  }
  .mobile{
    display: none !important;
  }
}

@media (min-width: 480px) and (max-width: 780px){
  .tablet{
    display: block !important;
  }
  .desktop{
    display: none !important;
  }
  .mobile{
    display: none !important;
  }
  .title h1{
    font-size: 35px !important;
  }
  .category h3{
    font-size: 25px !important;
  }
  .separador{
    max-width: 90%;
  }
}

@media (max-width: 480px){
  .mobile{
    display: block !important;
  }
  .desktop{
    display: none !important;
  }
  .tablet{
    display: none !important;
  }
  .title h1{
    font-size: 25px !important;
  }
  .category h3{
    font-size: 18px !important;
  }
  .separador{
    max-width: 95%;
  }
}
</style>